import { render, staticRenderFns } from "./NewLinkModal.vue?vue&type=template&id=5a63d79a&scoped=true"
import script from "./NewLinkModal.vue?vue&type=script&lang=js"
export * from "./NewLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a63d79a",
  null
  
)

export default component.exports